var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12.2726C24.5012 11.4546 24.4306 10.6379 24.289 9.83178H12.7429V14.4523H19.3544C19.2191 15.1898 18.9328 15.8928 18.5128 16.5189C18.0927 17.145 17.5476 17.6812 16.9104 18.0952V21.1023H20.8571C23.168 19.0142 24.5 15.9251 24.5 12.2726Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7431 24C16.044 24 18.83 22.9358 20.8573 21.1022L16.9106 18.1011C15.8113 18.8345 14.3984 19.2489 12.7431 19.2489C9.55071 19.2489 6.8395 17.1396 5.87041 14.2968H1.80546V17.3889C2.82402 19.3763 4.38629 21.0471 6.31776 22.2145C8.24924 23.382 10.4738 24.0001 12.7431 24Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87023 14.2968C5.35775 12.8071 5.35775 11.1938 5.87023 9.70411V6.61127H1.80528C0.947012 8.28373 0.5 10.1298 0.5 12.0019C0.5 13.874 0.947012 15.7201 1.80528 17.3926L5.87023 14.2968Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7431 4.75185C14.4883 4.72386 16.1748 5.36981 17.4381 6.5502L20.9351 3.12659C18.7187 1.0871 15.7831 -0.0330118 12.7431 0.000741248C10.4741 0.00119597 8.2498 0.619538 6.31845 1.78677C4.38711 2.95401 2.82467 4.62423 1.80546 6.61108L5.87041 9.70392C6.8395 6.86117 9.55071 4.75185 12.7431 4.75185Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.07da547f13762bf4e426eae241821e9f.svg";
export { ForwardRef as ReactComponent };